import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'

import { ENVIRONMENT } from '@yoshu-lib/core/tokens/environment.token'

export const devLoginInterceptor: HttpInterceptorFn = (req, next) => {
  const env = inject(ENVIRONMENT)

  if (env.name !== 'development') return next(req)

  if (req.url.endsWith('/auth/login/')) {
    return next(req.clone({ url: req.url.replace('/auth/login/', '/auth/dev-login/') }))
  }

  return next(req)
}
